// extracted by mini-css-extract-plugin
export default {"scroll":"Header_scroll__eaVD7","logo":"Header_logo__DOrAl","nav":"Header_nav__lwdu4","menu":"Header_menu__2lFmB","menuNav":"Header_menuNav__RlGtU","open":"Header_open__notIS"};